export class CertificationDetail {
    boardName: string;
    city: string;
    state: string;
    country: string;
    certificationDate: Date;
}
